export class UserPermission {
  id?: number;
  name?: string;
}
